import { render, staticRenderFns } from "./TaskLogDialog.vue?vue&type=template&id=36efc7f6"
import script from "./TaskLogDialog.vue?vue&type=script&lang=js"
export * from "./TaskLogDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports